/**
 * * Позиция
 */
export enum TirPmDrawerPositionEnum {
  Left = "left",
  Right = "right",
  Top = "top",
  Bottom = "bottom",
  Full = "full"
}
